import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { ArrowLeftOutlined, EditOutlined, SaveOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import defaultImageBtn from '../../assets/images/png_icon_action_default.png'
import api from "../../API";
import Phone from "../../Components/Phone";
import { Button, Table, Input,  Typography, Row, Col, Form, DatePicker, TimePicker, Select, message, Space, Transfer, Card, Tag } from "antd";
const fieldList = [
  {
      key: 'table_key_1',
      value: 'table_value_1',
      style: 'table_style_1'
  },
  {},
  {
      key: 'table_key_2',
      value: 'table_value_2',
      style: 'table_style_2'
  },
  {
      key: 'table_key_3',
      value: 'table_value_3',
      style: 'table_style_3'
  },
  {
      key: 'table_key_4',
      value: 'table_value_4',
      style: 'table_style_4'
  },
  {
      key: 'table_key_5',
      value: 'table_value_5',
      style: 'table_style_5'
  }
];
const buttonList = [
  {
      title: 'button_1_title',
      icon: 'button_1_icon',
      type: 'button_1_type',
      payload: 'button_1_payload'
  },
  {
      title: 'button_2_title',
      icon: 'button_2_icon',
      type: 'button_2_type',
      payload: 'button_2_payload'
  },
  {
      title: 'button_3_title',
      icon: 'button_3_icon',
      type: 'button_3_type',
      payload: 'button_3_payload'
  },
  {
      title: 'button_4_title',
      icon: 'button_4_icon',
      type: 'button_4_type',
      payload: 'button_4_payload'
  }
];
const optionTypeNews=[
  {
      value: 'transaction_billing',
      label: 'Hóa đơn',
  },
  {
      value: 'transaction_order',
      label: 'Đơn hàng',
  },
  {
      value: 'transaction_reward',
      label: 'Tích điểm',
  },
  {
      value: 'transaction_contract',
      label: 'Hợp đồng',
  },
  {
      value: 'transaction_booking',
      label: 'Lịch hẹn',
  },
  {
      value: 'transaction_membership',
      label: 'Thành viên',
  },
  {
      value: 'transaction_event',
      label: 'Sự kiện',
  },
  {
      value: 'transaction_transaction',
      label: 'Giao dịch',
  },
  {
      value: 'transaction_account',
      label: 'Tài khoản',
  },
  {
      value: 'transaction_internal',
      label: 'Nội bộ',
  },
  {
      value: 'transaction_partnership',
      label: 'Đối tác',
  },
  {
      value: 'transaction_education',
      label: 'Học vụ',
  },
  {
      value: 'transaction_rating',
      label: 'Đánh giá',
  }
];
const contactColumns = [
  {
    title: "Contact Name",
    dataIndex: "display_name",
  },
  {
    title: "Phone",
    dataIndex: "phone",
  }
];

const zaloGroupColumns = [
  {
    title: "Groups Name",
    dataIndex: "display_name",
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (status) => {
      if(status === "enabled")  return (<Tag color="#87d068">{status.toUpperCase()}</Tag>);
      return (<Tag color="#f50">{status.toUpperCase()}</Tag>)
    }
  }
];

function Campaign({cmpType, group}) {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const [detailInfo, contacts, segments, segmentsAndContacts, templates, oaccounts, zalogroups] = location.state;
  const [form] = Form.useForm()
  const [phone, setPhone] = useState({});
  const [loading, setLoading] = useState({spin: false, contact: false, btn: false});
  const [options1, setOptions1] = useState([]);
  const [options2, setOptions2] = useState([]);
  const [options3, setOptions3] = useState([]);
  const [targetKeys, setTargetKeys] = useState([]);
  const [OAName, setOAName] = useState(null)
  const [recipientData, setRecipientData] = useState([]);
  const filterRecipientsByOAID= useRef([]);
  const messagesOf1Cmp = useRef([]);
  const zaloIdsOfMessages = useRef([]);
  const now = useRef((new Date()).toLocaleDateString('en-CA'));
  const replaceName = {consultant: 'normal', transaction: 'template', promotion: 'template'};
  const replaceTplId = {consultant:'consultingTplId', transaction: 'transactionalTplId', promotion: 'promotionTplId'} 
  const getButtons = (templateItem) => buttonList.reduce((prevArr, obj) => templateItem[obj.title]? [...prevArr, {
    title: templateItem[obj.title],
    image_icon: templateItem[obj.icon]? JSON.parse(templateItem[obj.icon]).url: '',
    type: templateItem[obj.type],
    payload: (['show','hide'].includes(templateItem[obj.type].split('.').pop())? templateItem[obj.payload]: JSON.parse(templateItem[obj.payload]))
  }]: prevArr, [])
  const msgObj = {
    normal: {
      getPhoneProps: (phone) => ({
        imageURL: phone.templateType === 'image' && phone.templateFile? phone.templateFile.url: null,
        msgType:'normal',
        textMsg: phone.templateText,
        fileMsg: phone.templateType === 'attachment' && phone.templateFile,
        OAName: OAName
      }),
      getMessageOnPhone: (templateItem) => ({
        templateFile: templateItem.template_file && JSON.parse(templateItem.template_file),
        templateText: templateItem.template_text,
        templateType: templateItem.template_type 
      }),
      getMessage: async (templateItem, OAAccountId) => {
        try {
          let messageBody;
          if(templateItem.template_type === 'text') messageBody = JSON.stringify({message: { text: templateItem.template_text.replace(/\n/g,"<br/>")}}) 
          else if(templateItem.template_type === 'image') {
            messageBody = {
              message:  {
                text: templateItem.template_text.replace(/\n/g,"<br/>"),
                attachment: {
                  type: "template",
                  payload: {
                    template_type: "media",
                    elements: [{
                        media_type: templateItem.template_media_type,
                        url: JSON.parse(templateItem.template_file).url
                    }]
                  }
                }
              }}
              if(templateItem.template_media_type === "gif") {
                  messageBody.message.attachment.payload.elements[0].width = 500;
                  messageBody.message.attachment.payload.elements[0].height = 500;
              }
              messageBody = JSON.stringify(messageBody)
          } else if(templateItem.template_type === "attachment") {
            let fileObj = JSON.parse(templateItem.template_file);
            messageBody = JSON.stringify({
              message: {
                attachment: {
                  type: "file",
                  payload: {
                    token: await api.getFileToken(fileObj.url, fileObj.name, OAAccountId) 
                  }
                }
            }})
          }
          return messageBody;
        } catch (error) {
          throw error;
        }
      }
    },
    template: {
      getPhoneProps: (phone, cmpType) => ({
        imageURL: phone.banner,
        msgType:'template',
        buttons:phone.buttons,
        header: {iconType: cmpType + 'Icon', content: phone?.templatePayloadType || cmpType ==='transaction'? phone?.templatePayloadType: 'TIN TRUYỀN THÔNG'},
        table: phone.table,
        headerMessage: {content: phone.headerTitleText, align: phone.headerTitleAlignment},
        subHeaderMessage: {content: phone.headerText, align: phone.headerTextAlignment},
        subFooterMessage: {content: phone.footerText, align: phone.footerAlignment},
        OAName: OAName
      }),

      getMessageOnPhone: (templateItem) => ({
        banner: JSON.parse(templateItem.banner_url).url,
        headerTitleText: templateItem.header_title_text,
        headerTitleAlignment: templateItem.header_title_alignment,
        headerText: templateItem.header_text,
        headerTextAlignment: templateItem.header_text_alignment,
        footerText: templateItem.footer_text,
        footerAlignment: templateItem.footer_alignment,
        templatePayloadType: optionTypeNews.find(option => option.value === templateItem?.template_payload_type)?.label?.toUpperCase(),
        table: fieldList.map((obj) =>  ({
              key: templateItem[obj.key],
              value: templateItem[obj.value],
              style: templateItem[obj.style]
          })).filter(value => value.key || value.value),
        buttons: buttonList.map(obj =>  {
          return { 
              title: templateItem[obj.title],
              image: templateItem[obj.icon]? [JSON.parse(templateItem[obj.icon])]: [{url: defaultImageBtn}],
          }
        }).filter(btn => btn.title)
      }),

      getMessage: (templateItem, OAAccountId) => {
        let messageBody = {
          message: {
            attachment: {
              type: "template",
              payload: {
                template_type: templateItem?.template_payload_type || templateItem.templateType,
                language: templateItem?.template_payload_lang || 'VI',
                elements: [
                  {
                    image_url: JSON.parse(templateItem.banner_url).url,
                    type: "banner"
                  },
                  {
                    type: "header",
                    content: templateItem.header_title_text.replace(/\n/g,"<br/>"),
                    align: templateItem.header_title_alignment
                  },
                  {
                      type: "text",
                      align: templateItem.header_text_alignment,
                      content: templateItem.header_text.replace(/\n/g,"<br/>")
                  },
                  {
                    type: "table",
                    content: fieldList.reduce((prevArr, obj, i) => {
                      if(templateItem[obj.key]){
                        if(["Trạng thái", "Status"].includes(templateItem[obj.key])) return [...prevArr, {key: templateItem[obj.key], value: templateItem[obj.value], style: templateItem[obj.style]}] 
                        else return [...prevArr, {key: templateItem[obj.key], value: templateItem[obj.value]}]
                      } 
                      return prevArr;
                    }, [])
                  },
                  {
                    type: "text",
                    align: templateItem.footer_alignment,
                    content: templateItem.footer_text.replace(/\n/g,"<br/>")
                  }
                ],
              }
            }
          }
        };
        if(getButtons(templateItem).length) messageBody.message.attachment.payload.buttons = getButtons(templateItem);
        messageBody = JSON.stringify(messageBody);
        return Promise.resolve(messageBody);
      }
    }
  }

  useEffect(() => {
    setLoading({...loading, spin: true, contact: true});
    setOptions1(templates.map((obj) => ({value: obj.id, label: obj.templateCode })));
    setOptions2([{value: 'All', label: 'All'}, ...segments.map(({id: value, segmentName: label}) => ({value, label}))]);
    setOptions3(oaccounts.map((oaccount, i) => ({ value: i, label: oaccount.accountName})))
    if(!group) filterRecipientsByOAID.current=contacts.concat();
    else filterRecipientsByOAID.current = zalogroups.concat();
    if(detailInfo) {
      if(!group) setRecipientData(contacts.filter(contact => contact.accountId === detailInfo.accountId));
      else setRecipientData(zalogroups.filter(zalogroup => zalogroup.accountId === detailInfo.accountId));
      api.list_messages_byCmpId(detailInfo.campaignId)
      .then(messages => {
          const [ids, msgs] = messages.reduce((prevArr, obj) => [[...prevArr[0], obj.zaloUid? obj.zaloUid: obj.zaloGid], [...prevArr[1], obj]],[[],[]]);
          const OAAccountIndex = oaccounts.findIndex(oaccount => oaccount.id === detailInfo.accountId)
          zaloIdsOfMessages.current = ids;
          messagesOf1Cmp.current = msgs;
          form.setFieldsValue({
            campaignName: detailInfo.campaignName,
            startDate: dayjs(detailInfo.startDate),
            startTime: dayjs(dayjs(detailInfo.startDate).format("YYYY-MM-DD") + detailInfo.startTime),
            templateId: detailInfo.templateId,
            OAAccountIndex,
            recipientIds: group? zalogroups.reduce((prevArr,{key, group_id}) => zaloIdsOfMessages.current.includes(group_id)? [...prevArr, key]: prevArr,[]):
            contacts.reduce((prevArr,{key, zaloUid}) => zaloIdsOfMessages.current.includes(zaloUid)? [...prevArr, key]: prevArr,[])
          });
          now.current = (new Date(detailInfo.createDate)).toLocaleDateString('en-CA');
          setOAName(oaccounts[OAAccountIndex].accountName);
          handleSelectedTemplateId(detailInfo.templateId);
      })
      .catch(err => message.error(err.message))
    }
      setLoading({...loading, spin: false, contact: false})
  },[]);

  function handleSelectedOAAccount (selectedValue) {
    if(!group) {
      filterRecipientsByOAID.current = contacts.filter(contact => contact.OAId === oaccounts[selectedValue].OAId);
      form.setFieldValue("recipientIds", contacts.reduce((prevArr,{key, zaloUid, OAId}) => zaloIdsOfMessages.current.includes(zaloUid) && OAId === oaccounts[selectedValue].OAId? [...prevArr, key]: prevArr,[]));
    } 
    else {
      filterRecipientsByOAID.current = zalogroups.filter(zalogroup => zalogroup.OAId === oaccounts[selectedValue].OAId);
      form.setFieldValue("recipientIds", zalogroups.reduce((prevArr,{key, group_id, OAId}) => zaloIdsOfMessages.current.includes(group_id) && OAId === oaccounts[selectedValue].OAId? [...prevArr, key]: prevArr,[]));
    }
    setOAName(oaccounts[selectedValue].accountName);
    setRecipientData(filterRecipientsByOAID.current)
  }

  function handleSelectedTemplateId(selectedValue) {
    const templateItem = templates.find(obj => obj.id === selectedValue);
    setPhone(msgObj[replaceName[cmpType]].getMessageOnPhone(templateItem))
  }

  function handleSelectedSegment(selectedValue) {
    if(selectedValue === 'All') setRecipientData(filterRecipientsByOAID.current);
    else {
      let recipientIds = segmentsAndContacts.reduce((prevArr, obj) => obj.segmentId === selectedValue? [...prevArr, obj.contactId]: prevArr, [])
      setRecipientData(filterRecipientsByOAID.current.filter(obj=> recipientIds.includes(obj.key)))
    }
  }

  async function handleSubmit(values) {
    let cmpId = null;
    try {
      setLoading({...loading, btn: true})
      const {OAAccountIndex, campaignName, startDate, startTime, templateId, recipientIds} = values;
      const sendRecipients = group? zalogroups.reduce((prevArr, {key, group_id}) => recipientIds.includes(key)? [...prevArr, {zaloGid: group_id}]: prevArr, []):
       contacts.reduce((prevArr, {key, zaloUid, phone}) => recipientIds.includes(key)? [...prevArr, {zaloUid, phone}] :  prevArr, []);
      const sendTpl = templates.find(({id}) =>  id === templateId);
      let campaignObj = {
        campaignName, 
        startDate: (new Date(startDate)).toLocaleDateString('en-CA'), 
        startTime: (new Date(startTime)).toLocaleTimeString('it-IT'),
        templateId,
        template_type: group? "gmfconsultant": cmpType,
        msgVolume: sendRecipients.length,
        createDate: now.current,
        userId: user?.userId,
        accountId: oaccounts[OAAccountIndex].id,
        OAId: oaccounts[OAAccountIndex].OAId
      };
      const [responseCmp, messageBody] = await Promise.all([
        detailInfo? api.update_campaignById(detailInfo.campaignId, campaignObj): api.create_new_campaign(campaignObj),
        msgObj[replaceName[cmpType]].getMessage(sendTpl, OAAccountIndex)
      ])  
      cmpId = detailInfo? detailInfo.campaignId: responseCmp.result.insertId;
      const messageArr = sendRecipients.map((obj) =>{
        let msg = {
          campaignId: cmpId,
          accountId: oaccounts[OAAccountIndex].id,
          OAId: oaccounts[OAAccountIndex].OAId,
          userId: user?.userId,
          [replaceTplId[cmpType]]: templateId,
          zaloUid: obj?.zaloUid,
          zaloGid: obj?.zaloGid,
          phoneNumber: obj?.phone,
          messageBody,
          insertAt: (new Date()).toLocaleDateString('en-CA')
        }
        let indexMsg = group? messagesOf1Cmp.current.findIndex(obj => obj?.zaloGid === obj.zaloGid):
         messagesOf1Cmp.current.findIndex(obj => obj?.zaloUid === obj.zaloUid);
        if(indexMsg !== -1) {
          msg.msgId = messagesOf1Cmp.current[indexMsg].msgId;
          msg.insertAt = now.current;
        }
        return msg;
      });
      console.log("msg", messageArr)
      console.log(zalogroups)
      if(detailInfo){
        const deleteMessages = group? messagesOf1Cmp.current.filter(obj => sendRecipients.every((sendObj) => sendObj?.zaloGid !== obj.zaloGid)):
          messagesOf1Cmp.current.filter(obj => sendRecipients.every((sendObj) => sendObj.zaloUid !== obj.zaloUid));
        const updatesMessages = group? messageArr.filter(obj1 => obj1.msgId && messagesOf1Cmp.current.some(obj2 => obj2.zaloGid === obj1.zaloGid)):
          messageArr.filter(obj1 => obj1.msgId && messagesOf1Cmp.current.some(obj2 => obj2.zaloUid === obj1.zaloUid));
        const createMessages = messageArr.filter(obj => !(obj.msgId));
        await Promise.all([
          ...deleteMessages.map(obj => obj && api.delete_message_byId(obj.msgId)),
          ...createMessages.map(obj => obj && api.create_new_message(obj)),
          ...updatesMessages.map(obj => obj && api.update_message_byId(obj.msgId, obj))
        ]);
      } else await Promise.all(messageArr.map(msg => api.create_new_message(msg)));
      message.success(responseCmp.message);
      navigate(`/send/${group? "gmfconsultant" : cmpType}s`, { replace: true });
    } catch (error) {
      message.error(error.message);
      if(cmpId !== null && !detailInfo) api.delete_campaign_byId(cmpId);
    } finally {
      setLoading({...loading, btn: false})
    }
  }
  
  return (
    <Card 
        style={{height: '100%', margin: "0 auto", boxShadow: "1px 1px 5px #ccc", borderRadius: 10 }}
        title={
        <Space>
            <Link to={`/send/${group? 'gmfconsultant': cmpType}s`} replace={true}>
                    <Button style={{width: 50}} icon={<ArrowLeftOutlined />}></Button>
            </Link>
            <Typography.Title level={5} style={{margin: 0}}>{detailInfo? 'Update ': 'Create new '}{group? 'GMF '+ cmpType: cmpType} campaign</Typography.Title>
        </Space>
        }
        loading={loading.spin}
    >
      <Form name="campaignform" label="campaign form" layout="vertical" form={form} onFinish={handleSubmit}>
        <Row gutter={16}>
          <Col xxl={14} xl={14} lg={14} md={24} sm={24} xs={24}>
            <Form.Item label='OA Account'
                      name="OAAccountIndex"
                      rules={[{required: true, message: 'The OA Account cannot be empty'}]}>
              <Select 
                options={options3} 
                placeholder="Select OA Account" 
                showSearch
                onChange={handleSelectedOAAccount}
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
            <Form.Item label='Name'
                       name='campaignName'
                       rules={[{required: true, message: 'The campaign name cannot be empty'}]}>
              <Input placeholder="Enter campaign name..." />
            </Form.Item>
            <Space styles={{item: {width: '100%'}}} style={{width: '100%'}}>
              <Form.Item label='Schedule Date'
                        name='startDate'
                        rules={[{required: true, message: 'The date cannot be empty'}]}>
                <DatePicker style={{width: '100%'}} disabledDate={(current) => current && current < dayjs().startOf('day')}/>
              </Form.Item>
              <Form.Item label='Schedule Time'
                        name='startTime'
                        rules={[{required: true, message: 'The time cannot be empty'}]}>
                <TimePicker format="HH:mm" style={{width: '100%'}}/>
              </Form.Item>
            </Space>
            <Form.Item  label="Template code"
                        name="templateId"
                        rules={[{required: true, message: 'Template code must be selected'}]}>
              <Select 
                options={options1} 
                placeholder="Select template code" 
                showSearch 
                onChange={handleSelectedTemplateId}
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
              />
            </Form.Item>
            { !group &&
              <Form.Item label="Choose segments">
              <Select 
                options={options2} 
                placeholder="Select segment" 
                onChange={handleSelectedSegment} popupMatchSelectWidth={false}
                showSearch 
                optionFilterProp="label"
                filterOption={(input, option) =>
                  (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
              />
              </Form.Item>
            }
            <Form.Item  label={`Choose ${group? 'GMF ': 'contacts'}`} 
              name='recipientIds' 
              rules={[{required: true, message: `${group? 'GMF ': 'contacts'} must be selected`}]}
              style={{width: '100%'}}
              valuePropName="targetKeys" 
              getValueFromEvent={(nextTargetKeys) => nextTargetKeys}>
              <Transfer
                titles={['Source', 'Target']}
                dataSource={recipientData.map(recipient => {
                  let recipientObj = { key: recipient.key, display_name: group? recipient.name: recipient.display_name}
                  if(!group) recipientObj.phone = recipient.phone;
                  else recipientObj.status = recipient.status;
                  return recipientObj;
                })}
                targetKeys={targetKeys}
                showSearch
                showSelectAll={false}
                listStyle={{width: '40%'}}
                onChange={(nextTargetKeys)=>{setTargetKeys(nextTargetKeys)}}
                filterOption={(input, item) => ((item.phone && String(item.phone).includes(input)) || (item.status && String(item.status).includes(input?.toLowerCase())) || item.zaloUid?.includes(input))}>
                {({
                  filteredItems,
                  onItemSelect,
                  onItemSelectAll,
                  selectedKeys: listSelectedKeys,
                }) => {
                  const rowSelection = {
                    onChange(selectedRowKeys) {
                      onItemSelectAll(selectedRowKeys, 'replace');
                    },
                    selectedRowKeys: listSelectedKeys,
                    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT, Table.SELECTION_NONE],
                  };
                  return (
                    <Table
                      loading= {loading.contact}
                      rowSelection={rowSelection}
                      columns={group? zaloGroupColumns: contactColumns}
                      dataSource={filteredItems}
                      size="small"
                      scroll={{x: '40%'}}
                      onRow={({ key}) => ({
                        onClick: () => {
                          onItemSelect(key, !listSelectedKeys.includes(key));
                        },
                      })}
                      pagination={{
                        position: ["bottomCenter"],
                        showSizeChanger: false, // Disable page size changer
                        pageSize: 5
                      }}
                    />
                  );
                }}
              </Transfer>
            </Form.Item>
          </Col>
          <Col xxl={10} xl={10} lg={10} md={24} sm={24} xs={24}>
            <Phone phoneProps={msgObj[replaceName[cmpType]].getPhoneProps(phone, cmpType)}/>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item style={{marginTop: 10}}>
              <Button type="primary" htmlType="submit" loading={loading.btn} icon={detailInfo? <EditOutlined/>: <SaveOutlined/>}>{detailInfo? "Update": "Save"}</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  )
}

export default Campaign;
